import React, { useEffect } from 'react';
import imagesLoaded from 'imagesloaded';
import PropTypes from 'prop-types';

// import MediaOne from './partials/media/media-one';
// import ProductDetailOne from './partials/details/detail-one';
// import DescOne from './partials/description/desc-one';
// import RelatedProducts from './partials/related-products';
// import StickyBar from './partials/sticky-bar';

// import QuickView from '../../features/product/common/quickview';

import ProductMedia from 'lib/product/ProductMedia';
import ProductDetail from '../ProductDetail';
import * as typedef from 'lib/product/typedef';
import TabContents from '../TabContents';

const MainInformation = ({
  product,
  catalogueIds,
  onFirstItemAdded,
  categories,
  collections,
  specialProductCategories,
}) => {
  useEffect(() => {
    document
      .querySelector('.skel-pro-single')
      .classList.remove('loaded');

    let imgLoad = imagesLoaded('.product-main-image', {
      background: true,
    });

    imgLoad.on('done', function (instance, image) {
      document
        .querySelector('.skel-pro-single')
        ?.classList.add('loaded');
    });
  }, [product]);

  return (
    <>
      <div className="product-details-top skeleton-body">
        <div className="row skel-pro-single tw-h-full">
          <div className="col-md-6">
            <div className="skel-product-gallery tw-sticky tw-top-[100px]"></div>

            <ProductMedia product={product} />
          </div>

          <div className="col-md-6" style={{ position: 'unset' }}>
            <div className="entry-summary row">
              <div className="col-md-12">
                <div className="entry-summary1"></div>
              </div>

              <div className="col-md-12">
                <div className="entry-summary2"></div>
              </div>
            </div>

            <ProductDetail
              product={product}
              catalogueIds={catalogueIds}
              onFirstItemAdded={onFirstItemAdded}
              categories={categories}
              collections={collections}
              specialProductCategories={specialProductCategories}
            />
          </div>
        </div>
      </div>

      <TabContents
        productId={product.id}
        data={product.tab_contents}
      />
    </>
  );
};

MainInformation.propTypes = {
  product: typedef.Product,
  catalogueIds: PropTypes.string,
  onFirstItemAdded: PropTypes.func,
};

export default MainInformation;
